window.IllegalDeliveryRules = (() => { const exports = {};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectRule = selectRule;
exports.deliveryCopy = deliveryCopy;
function selectRule(snapshot, context, now = new Date()) {
    if (snapshot.schemaVersion !== 1 ||
        !Number.isFinite(Date.parse(snapshot.expiresAt)) ||
        now >= new Date(snapshot.expiresAt))
        return null;
    const candidates = snapshot.rules.filter((r) => {
        const a = r.applicability;
        if (r.approval.state !== "approved" ||
            !r.approval.by ||
            !r.approval.at ||
            !r.evidence.length ||
            !Number.isFinite(Date.parse(r.expiresAt)) ||
            now >= new Date(r.expiresAt) ||
            r.start === "unknown" ||
            !r.duration ||
            !Number.isSafeInteger(r.duration.min) ||
            !Number.isSafeInteger(r.duration.max) ||
            r.duration.min < 0 ||
            r.duration.max < r.duration.min ||
            !r.stages.length)
            return false;
        if (r.evidence.some((e) => !e.source ||
            !e.reference ||
            !Number.isFinite(Date.parse(e.verifiedAt)) ||
            new Date(e.verifiedAt) > now))
            return false;
        if (!a.countries.includes(context.country) || a.service !== context.service)
            return false;
        return ((!a.variantIds.length ||
            a.variantIds.includes(context.variantId || "")) &&
            (!a.productIds.length ||
                a.productIds.includes(context.productId || "")) &&
            (!a.providerIds.length ||
                a.providerIds.includes(context.providerId || "")) &&
            (!a.family || a.family === context.family) &&
            !!(a.variantIds.length ||
                a.productIds.length ||
                a.providerIds.length ||
                a.family));
    });
    const specificity = (r) => r.applicability.variantIds.length
        ? 4
        : r.applicability.productIds.length
            ? 3
            : r.applicability.providerIds.length
                ? 2
                : 1;
    candidates.sort((a, b) => specificity(b) - specificity(a));
    if (!candidates.length ||
        (candidates.length > 1 &&
            specificity(candidates[0]) === specificity(candidates[1])))
        return null;
    return candidates[0];
}
function deliveryCopy(snapshot, context, now = new Date()) {
    const rule = selectRule(snapshot, context, now);
    if (!rule?.duration)
        return {
            text: snapshot.fallback,
            version: snapshot.version,
            rule: null,
            dates: null,
        };
    if (rule.start === "order-created" && rule.merchantWaiting !== "included")
        return {
            text: snapshot.fallback,
            version: snapshot.version,
            rule: null,
            dates: null,
        };
    const start = {
        "order-created": "after your order is placed",
        "provider-received": "after the provider receives your order",
        "production-submitted": "after submission to production",
        "carrier-accepted": "after the carrier receives your package",
        unknown: "",
    }[rule.start];
    const days = rule.duration.unit === "business-days" ? "business days" : "calendar days";
    const waiting = rule.merchantWaiting === "included"
        ? ""
        : " Time before this stage is additional and is not included.";
    return {
        text: `Estimated ${rule.duration.min} to ${rule.duration.max} ${days} ${start}.${waiting}`,
        version: snapshot.version,
        rule: rule.id,
        dates: null,
    };
}

exports.snapshot = {"schemaVersion":1,"version":"2026-10-13.p1-draft.1","generatedAt":"2026-10-14T00:00:00Z","expiresAt":"2026-11-13T00:00:00Z","fallback":"Delivery timing depends on your items, destination and shipping service. We cannot confirm an arrival date before checkout.","splitCopy":"Items may arrive in separate packages. Track each package for its latest update.","rules":[{"id":"fih-standard-us-unverified","version":1,"applicability":{"variantIds":["50225399038240"],"productIds":["9958056493344"],"providerIds":[],"family":null,"countries":["US"],"service":"Standard"},"start":"unknown","stages":["provider-fulfillment","carrier-transit"],"duration":{"min":5,"max":10,"unit":"business-days"},"calendar":{"timezone":null,"cutoff":null,"holidays":[],"verifiedYears":[],"workingWeekdays":[]},"merchantWaiting":"unknown","evidence":[{"source":"Shopify Ajax shipping method description","reference":"DeliveryProfile/136859418912; Fih Black/M; P1 Ajax capture 2026-10-14","verifiedAt":"2026-10-14T00:00:00Z","semantics":"Description observed. Printify documents combined fulfillment and shipping, but profile edit provenance and merchant approval waiting are unverified."}],"expiresAt":"2026-11-13T00:00:00Z","approval":{"state":"draft","by":null,"at":null}},{"id":"fih-standard-ca-unverified","version":1,"applicability":{"variantIds":["50225399038240"],"productIds":["9958056493344"],"providerIds":[],"family":null,"countries":["CA"],"service":"Standard"},"start":"unknown","stages":["provider-fulfillment","carrier-transit"],"duration":{"min":13,"max":35,"unit":"business-days"},"calendar":{"timezone":null,"cutoff":null,"holidays":[],"verifiedYears":[],"workingWeekdays":[]},"merchantWaiting":"unknown","evidence":[{"source":"Shopify Ajax shipping method description","reference":"DeliveryProfile/136859418912; Fih Black/M; P1 Ajax capture 2026-10-14","verifiedAt":"2026-10-14T00:00:00Z","semantics":"Description observed. Printify documents combined fulfillment and shipping, but profile edit provenance and merchant approval waiting are unverified."}],"expiresAt":"2026-11-13T00:00:00Z","approval":{"state":"draft","by":null,"at":null}}]}; return exports; })();
